import * as React from 'react';
import { SVGProps } from 'react';

const IconTreeSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 2.5a1.5 1.5 0 1 1 2 1.415V5h3.085a1.5 1.5 0 1 1 0 1H4v2.5a.5.5 0 0 0 .5.5h2.585a1.5 1.5 0 1 1 0 1H4.5A1.5 1.5 0 0 1 3 8.5V3.915A1.5 1.5 0 0 1 2 2.5Z"
    />
  </svg>
);
export default IconTreeSizeXs;
